import * as React from 'react';
const SvgExternalLink = (props) => (
  <svg
    width={14}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5 7.58333V11.0833C10.5 11.3928 10.3771 11.6895 10.1583 11.9083C9.9395 12.1271 9.64275 12.25 9.33333 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V4.66667C1.75 4.35725 1.87292 4.0605 2.09171 3.84171C2.3105 3.62292 2.60725 3.5 2.91667 3.5H6.41667"
      stroke="url(#paint0_linear_177_30385)"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.75 1.75H12.25V5.25"
      stroke="url(#paint1_linear_177_30385)"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83301 8.16667L12.2497 1.75"
      stroke="url(#paint2_linear_177_30385)"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_177_30385"
        x1={6.125}
        y1={3.5}
        x2={6.125}
        y2={12.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8A90FF" />
        <stop offset={1} stopColor="#B15FDA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_177_30385"
        x1={10.5}
        y1={1.75}
        x2={10.5}
        y2={5.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8A90FF" />
        <stop offset={1} stopColor="#B15FDA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_177_30385"
        x1={9.04134}
        y1={1.75}
        x2={9.04134}
        y2={8.16667}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8A90FF" />
        <stop offset={1} stopColor="#B15FDA" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgExternalLink;
